import RIOSelect from '@rio-cloud/rio-uikit/Select';
import type React from 'react';
import { useLayoutEffect } from 'react';

import type { SelectOption } from './types';

interface SelectProps {
    options?: SelectOption[];
    onChange: (id?: SelectOption) => void;
    placeholder?: string;
    value?: SelectOption['id'] | null;
}

const Select: React.FC<SelectProps> = ({ options, onChange, placeholder, value }) => {
    useLayoutEffect(() => {
        document.querySelector(`[data-item-id="${value}"]`)?.classList.add('selected');
    }, [value]);

    return (
        <RIOSelect
            placeholder={placeholder}
            options={options}
            onChange={onChange}
            value={value ? [value] : undefined}
            className='w-fit'
            btnClassName='border-none bg-gray-darker text-white'
            dropdownClassName='select'
        />
    );
};

export default Select;
